import CryptoJS from "crypto-js";
import moment from "moment";

// Orquestrador único da cifra AES/CBC/PKCS7 usada em todo handshake com o
// ms-usuario que segue esse padrão (hoje: header X-Id-Usuario-Criptografado
// e o campo `aplicacao` do /auth/token-publico). IV = MMyyyydd (UTC) + N
// chars aleatórios. Cada finalidade usa sua própria chave (ver chamadores).
const CHAVE_AES_PADRAO = "cBmT7UMdFQkL4ckQUeFU^pULW$Yo8!h^";

export function cifrarAES(valor: string, chave: string = CHAVE_AES_PADRAO): string {
  const aleatorio = (Math.random() + 1).toString(36).substr(2, 8);
  const now_utc = moment.utc();

  const encrypted = CryptoJS.AES.encrypt(
    valor,
    CryptoJS.enc.Latin1.parse(chave),
    {
      iv: CryptoJS.enc.Latin1.parse(now_utc.format("MMYYYYDD") + aleatorio),
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC,
    },
  );

  return aleatorio + encrypted.toString();
}
